import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=74d21b06&scoped=true&"
import script from "./GameList.vue?vue&type=script&lang=js&"
export * from "./GameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_y5o36p7qrshhm4v7l6yk7rwfsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d21b06",
  null
  
)

export default component.exports